/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { Group } from '../../UNSAFE_Axis/axis.types';
import { ChartItem, ChartSeries, ValueFormats } from '../../UNSAFE_Chart';
import { VisTabularDatatip } from '../../PRIVATE_VisTabularDatatip';
import { TableRowData } from '../../PRIVATE_VisTabularDatatip';
/**
 * Returns the data required for the VisTabularDatatip to render.
 * @param activeInfo active item info.
 * @param series The array of chart series.
 * @param groups The array of chart groups.
 * @param valueFormats The array of chart series.
 * @param getDataItem function which returns chartItem
 */
export function getChartTabularData<K, D extends ChartItem<K>>(
  data: D,
  seriesValue: string,
  groupValue: string,
  valueFormats?: ValueFormats
) {
  //TODO: Use translation strings
  const value = data.value;
  const itemValue = valueFormats?.value?.format ? valueFormats?.value?.format?.(value) : value;
  const tableData: TableRowData[] = [];

  if (valueFormats?.series?.isDisplayed != false) {
    tableData.push({ key: valueFormats?.series?.label || 'Series', value: seriesValue });
  }
  if (valueFormats?.group?.isDisplayed != false) {
    tableData.push({ key: valueFormats?.group?.label || 'Group', value: groupValue });
  }
  if (valueFormats?.value?.isDisplayed != false) {
    tableData.push({ key: valueFormats?.value?.label || 'Value', value: itemValue });
  }
  return tableData;
}

export function getDefaultDatatipRenderer<
  K extends string | number,
  D extends ChartItem<K>
>(options: { series: ChartSeries<K, D>; groups: Group; valueFormats?: ValueFormats }) {
  return (context: { data: D }) => ({
    content: (
      <VisTabularDatatip
        tableData={getChartTabularData(
          context.data,
          options.series.name || options.series.id.toString(),
          options.groups.name || options.groups.id,
          options.valueFormats
        )}
      />
    ),
    borderColor: context.data.color || options.series.color
  });
}
